import React from 'react';
import classNames from 'classnames';

import { fontWeightEnum, Text, textVariantsEnum } from '@components/Text';

import styles from './Button.module.scss';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
import { TbLoader2 } from 'react-icons/tb';
import { buttonSizes } from './Button.constants';
const textSizeMap = {
  sm: textVariantsEnum.Text_sm,
  md: textVariantsEnum.Text_sm,
  lg: textVariantsEnum.Text_md,
};

export const ButtonComponent = ({
  text,
  id,
  variant = 'primary',
  size = buttonSizes.sm,
  width = 'content',
  icon,
  iconColor = 'inherit',
  iconPosition = 'left',
  iconRotation = '0',
  iconSize = 20,
  onClick,
  type = 'button',
  active,
  disabled,
  loading,
  style,
  className,
  onDoubleClick,
}) => {
  const buttonClass = classNames(
    styles.button,
    {
      [styles[`button_variant_${variant}`]]: variant,
      [styles[`button_size_${size}`]]: size,
      [styles[`button_size_icon_only`]]: !text,
      [styles[`button_width_${width}`]]: width,
      [styles[`button_icon_position_${iconPosition}`]]: iconPosition,
      [styles.disabled]: disabled,
      [styles.active]: active,
      [styles.loading]: loading,
    },
    className
  );
  const isClickUnavailable = loading || disabled;
  let iconToRender = icon;
  if (typeof icon === 'string') {
    iconToRender = (
      <SvgIcon
        src={icon}
        size={iconSize}
        color={iconColor}
        disabled={disabled}
        rotate={iconRotation}
      />
    );
  }
  return (
    <button
      className={buttonClass}
      disabled={disabled}
      onClick={isClickUnavailable ? () => null : onClick}
      onDoubleClick={isClickUnavailable ? () => null : onDoubleClick}
      style={style}
      type={type}
      id={id}
      data-testid="button-as"
    >
      <div
        className={styles.loader}
        data-testid={`button-loader-${loading ? 'active' : 'inactive'}`}
      >
        <TbLoader2 size={25} />
      </div>
      {iconToRender}
      {text && (
        <Text
          variant={textSizeMap[size]}
          fontWeight={fontWeightEnum.Medium}
          className={styles.buttonText}
        >
          {text}
        </Text>
      )}
    </button>
  );
};

ButtonComponent.displayName = 'Button';
